export default __webpack_public_path__ + "static/media/earth-globe.c653c6af.svg";